// This pattern was implemented by following
// https://codepen.io/luizdtna/pen/ydbYQq
import $ from "jquery";
import Base from "@patternslib/patternslib/src/core/base";
import _ from "underscore";
import "./calendar.scss";


$.extend(Date.prototype, {
//provides a string that is _year_month_day, intended to be widely usable as a css class
toDateCssClass:  function () {
    return '_' + this.getFullYear() + '_' + (this.getMonth() + 1) + '_' + this.getDate();
},
//this generates a number useful for comparing two dates;
toDateInt: function () {
    return ((this.getFullYear()*12) + this.getMonth())*32 + this.getDate();
},
toTimeString: function() {
    var hours = this.getHours(),
        minutes = this.getMinutes(),
        hour = (hours > 12) ? (hours - 12) : hours,
        ampm = (hours >= 12) ? ' pm' : ' am';
    if (hours === 0 && minutes===0) { return ''; }
    if (minutes > 0) {
    return hour + ':' + minutes + ampm;
    }
    return hour + ampm;
}
});

export default Base.extend({
    name: 'ploud-calendar',
    trigger: '.pat-ploud-calendar',
    parser: 'mockup',

    defaults: {
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      date: (new Date()),
      daycss: ["c-sunday", "", "", "", "", "", "c-saturday"],
      todayname: "Today",
      thismonthcss: "current",
      lastmonthcss: "outside",
      nextmonthcss: "outside",
      mode: "month",
      events_source: "/@@getPloudEvents",
      data: []
    },

    data: [],

    updateEvents: function (){
      var self = this;
      var url,
          data;

      if (self.options.events_source.length > 0) {
        if (self.options.events_source[0] == "/"){
          url = $("body").attr("data-portal-url") + self.options.events_source;
        } else if (self.options.events_source.indexOf("http") == 0){
          url = self.options.events_source;
        } else {
          url = window.location.href + "/" + self.options.events_source;
        }
      } else {
        return;
      }

      $('#ajax-spinner').show();
      $('table.calendar-table', self.$el).addClass('updating');

      data = {
        'date': self.options.date.toISOString(),
        'mode': self.options.mode
      }

      $.ajax({
          url: url,
          data: data,
          dataType: 'json',
          success: function(data) {
            if (data && data.length) {
              self.data = [];
              $.each(data, function(key, val) {
                // Convert ISO date into Date object
                if (val.start){
                  val.start = new Date(val.start);
                }
                if (val.end){
                  val.end = new Date(val.end);
                }
                self.data.push(val);
              });
              self.draw();
            }
          },
          complete: function(jqXHR, textStatus ) {
            $('#ajax-spinner').hide();
            $('table.calendar-table', self.$el).removeClass('updating');
          }
      });
    },

    draw: async function () {
      const CalendarTemplate = (await import("./tmpls/calendar.html")).default;
      const bootstrap = await import("bootstrap");
      // Destroy all popovers
      $("[data-bs-toggle='popover']").popover('dispose');

      var self = this;
      var t = _.template(CalendarTemplate);
      self.$el.html(t(self.options));

      $('.' + (new Date()).toDateCssClass(), self.$el).addClass('today');
      if (self.options.mode === 'year') {
          self.yearAddEvents(self.data, self.options.date.getFullYear());
      } else if (self.options.mode === 'month' || self.options.mode === 'week') {
          $.each(self.data, function(key, val) {
            self.monthAddEvent(key, val);
          });
      } else {
          $.each(self.data,  function(key, val) {
            self.dayAddEvent(key, val);
          });
      }

      // Create popover for year
      var $t = $(".js-cal-years"),
      s = '',
      y = self.options.date.getFullYear() - 2,
      l = y + 5;
      for (; y < l; y++) {
        s += '<button class="btn btn-default btn-lg btn-block js-cal-option" data-date="' + (new Date(y, 1, 1)).toISOString() + '" data-mode="year">'+y + '</button>';
      }
      new bootstrap.Popover($t, {content: s, html: true, placement: 'bottom'});
    },

    yearAddEvents: function (events, year) {
      var self = this;
      var counts = [0,0,0,0,0,0,0,0,0,0,0,0];
      $.each(events, function (i, v) {
        if (v.start.getFullYear() === year) {
            counts[v.start.getMonth()]++;
        }
      });
      $.each(counts, function (i, v) {
        if (v!==0) {
            $('.month-'+i).append('<span class="badge rounded-pill text-bg-primary">'+v+'</span>');
        }
      });
    },

    monthAddEvent: function(index, event) {
      var self = this;
      var $event = $('<div/>', {'class': 'event', text: event.title, title: event.title, 'data-index': index, 'data-bs-toggle': 'popover'})
                   .data('event', event),
          e = new Date(event.start),
          dateclass = e.toDateCssClass(),
          day = $('.' + e.toDateCssClass()),
          empty = $('<div/>', {'class':'clear event', html:'&nbsp;'}),
          numbevents = 0,
          time = event.start.toTimeString(),
          endday = event.end && $('.' + event.end.toDateCssClass()).length > 0,
          checkanyway = new Date(e.getFullYear(), e.getMonth(), e.getDate()+40),
          existing,
          i;
      $event.toggleClass('all-day', !!event.allDay);
      $event.toggleClass('occurrence', !!event.occurrence);
      $event.addClass(event.ev_class);
      if (!!time) {
        $event.html('<strong>' + time + '</strong> ' + $event.html());
      }
      if (!event.end) {
        $event.addClass('begin end');
        $('.' + start.toDateCssClass()).append($event);
        return;
      }

      while (e <= event.end && (day.length || endday || self.options.date < checkanyway)) {
        if(day.length) {
          existing = day.find('.event').length;
          numbevents = Math.max(numbevents, existing);
          for(i = 0; i < numbevents - existing; i++) {
            day.append(empty.clone());
          }
          day.append(
            $event.
            toggleClass('begin', dateclass === event.start.toDateCssClass()).
            toggleClass('end', dateclass === event.end.toDateCssClass())
          );
          $event = $event.clone();
          $event.data('event', event);
          $event.html('&nbsp;');
        }
        e.setDate(e.getDate() + 1);
        dateclass = e.toDateCssClass();
        day = $('.' + dateclass);
      }
    },

    dayAddEvent: function(index, event) {
      var self = this;
      if (!!event.allDay) {
        self.monthAddEvent(index, event);
        return;
      }
      var $event = $('<div/>', {'class': 'event', text: event.title, title: event.title, 'data-index': index, 'data-bs-toggle': 'popover'})
                   .data('event', event),
          start = event.start,
          end = event.end || start,
          time = start.toTimeString(),
          hour = start.getHours(),
          timeclass = '.time-22-0',
          startint = start.toDateInt(),
          dateint = self.options.date.toDateInt(),
          endint = end.toDateInt();
      if (startint > dateint || endint < dateint) { return; }

      if (!!time) {
        $event.html('<strong>' + time + '</strong> ' + $event.html());
      }
      $event.toggleClass('begin', startint === dateint);
      $event.toggleClass('end', endint === dateint);
      if (hour < 6) {
        timeclass = '.time-0-0';
      }
      if (hour < 22) {
        timeclass = '.time-' + hour + '-' + (start.getMinutes() < 30 ? '0' : '30');
      }
      $(timeclass).append($event);
    },

    init: async function() {
      // Allow extra tags and attributes in tooltips
      // https://getbootstrap.com/docs/5.2/getting-started/javascript/#sanitizer
      const bootstrap = await import("bootstrap");
      const myDefaultAllowList = bootstrap.Tooltip.Default.allowList;
      myDefaultAllowList.button = ['data-date', 'data-mode'];

      var self = this;

      self.$el.on('click', '.js-cal-prev', function () {
        switch(self.options.mode) {
          case 'year': self.options.date.setFullYear(self.options.date.getFullYear() - 1); break;
          case 'month': self.options.date.setMonth(self.options.date.getMonth() - 1); break;
          case 'week': self.options.date.setDate(self.options.date.getDate() - 7); break;
          case 'day':  self.options.date.setDate(self.options.date.getDate() - 1); break;
        }
        self.updateEvents();
        self.draw();
      }).on('click', '.js-cal-next', function () {
        switch(self.options.mode) {
          case 'year': self.options.date.setFullYear(self.options.date.getFullYear() + 1); break;
          case 'month': self.options.date.setMonth(self.options.date.getMonth() + 1); break;
          case 'week': self.options.date.setDate(self.options.date.getDate() + 7); break;
          case 'day':  self.options.date.setDate(self.options.date.getDate() + 1); break;
        }
        self.updateEvents();
        self.draw();
      }).on('click', '.event', async function (e) {
        const bootstrap = await import("bootstrap");
        var $t = $(this),
            index = +($t.attr('data-index')),
            data = $t.data('event'),
            time;

        e.stopPropagation();

        time = data.start.toTimeString();
        if (time && data.end) { time = time + ' - ' + data.end.toTimeString(); }
        $t.data('popover',true);
        var popover_content = '<p><strong>' + time + '</strong></p>' + data.text + '<br/><br/><a class="btn btn-success" href="' + data.url + '">Read more</a>';
        var popover = bootstrap.Popover.getOrCreateInstance($t, {content: popover_content, html: true, placement: 'auto'});
        popover.show();
        return false;
      });

      $(document.body).on('click', '.js-cal-option', function () {
        var $t = $(this), o = $t.data(), update=false;
        if (o.date) {
          o.date = new Date(o.date);
          if (o.date.getMonth() !== self.options.date.getMonth()){
            update = true;
          }
          if (self.options.mode === "year" && o.date.getYear() !== self.options.date.getYear()){
            update = true;
          }
        }
        if (o.mode && o.mode !== self.options.mode){
          update = true;
        }

        $.extend(self.options, o);

        if (update) {
          self.updateEvents();
        }
        self.draw();
      })

      self.updateEvents();
      self.draw();
    }
});
